import React from "react";
import styled, { css } from "styled-components";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";
import { PASSWORD_RESTORE_TAB_ID } from "./Auth";

const Container = styled.div`
  direction: ${({ theme }) => theme.direction};
  font-size: ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
    ? fontSize(14)
    : fontSize(12)};
  line-height: 18px;
  color: ${(props) =>
    props.error
      ? process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
        ? "red"
        : "tomato"
      : process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
      ? "green"
      : "rgb(96, 163, 28)"};

  ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      padding: 7px;
      border-radius: 30px;
      background-color: #ffffff;
      text-align: center;
    `};
`;

const ToggleTabButton = styled.button`
  padding: 0;
  border: 0;
  color: inherit;
  font-size: inherit;
  background: none;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

type Props = {
  style?: Object,
  error: string,
  notification: string,
};

function Message(props: Props) {
  if (props.error) {
    return (
      <Container style={props.style} error>
        {props.error}
      </Container>
    );
  }

  return (
    <Container style={props.style}>
      {props.notification}
      {props.notificationType === "restorePasswordWithEmail" && (
        <ToggleTabButton
          onClick={() => props.toggleTab(PASSWORD_RESTORE_TAB_ID, "phone")}
        >
          <Gettext>Don't have an access to your email?</Gettext>
        </ToggleTabButton>
      )}
    </Container>
  );
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/Auth/Message.js